export interface Vec2 {
  x: number
  y: number
}

export const enum DietType {
  Herbivore = 'herbivore',
  Carnivore = 'carnivore',
  Omnivore = 'omnivore',
}

/** 生物の個性パラメーター（遺伝形質） */
export interface Traits {
  /** 移動速度 (px/frame) */
  speed: number
  /** 視野半径 (px) */
  visionRange: number
  /** 体のサイズ (半径 px) */
  size: number
  /** 食性 */
  diet: DietType
  /** HSL の色相 (0-360) */
  hue: number
  /** エネルギー消費率の乗数 */
  metabolismRate: number
}
